import { useState } from 'react';

const REASON_TEXT = {
  unreachable: 'unreachable',
  not_configured: 'not configured',
  probe_error: 'probe error',
  ses_sender_unverified: 'sender not verified',
  ses_access_denied: 'access denied',
  ses_not_configured: 'not configured',
  ses_error: 'error',
};

// Reusable integration pill: instant config state + on-click reachability test.
export default function IntegrationStatusPill({ label, configured, onTest }) {
  const [phase, setPhase] = useState('idle'); // idle | checking | done
  const [result, setResult] = useState(null); // { ok, reason? }

  if (!configured) {
    return (
      <span className="integ-pill integ-pill--muted" role="status">{label}: not configured</span>
    );
  }

  const runTest = async () => {
    setPhase('checking'); setResult(null);
    try { setResult(await onTest()); } catch { setResult({ ok: false, reason: 'probe_error' }); }
    finally { setPhase('done'); }
  };

  let tone = 'loading';
  let text = `${label}: not checked`;
  if (phase === 'checking') { tone = 'loading'; text = `${label}: checking…`; }
  else if (phase === 'done' && result) {
    if (result.ok) { tone = 'ok'; text = `${label}: connected`; }
    else { tone = 'bad'; text = `${label}: ${REASON_TEXT[result.reason] || 'unreachable'}`; }
  }

  return (
    <span className="integ-pill-row">
      <span className={`integ-pill integ-pill--${tone}`} role="status">{text}</span>
      <button type="button" className="integ-test-btn" onClick={runTest} disabled={phase === 'checking'}>
        Test connection
      </button>
    </span>
  );
}
